import { Check, Star, X } from "lucide-react";

const fmtUses = (n) => (n >= 1e6 ? `${(n / 1e6).toFixed(1)}M` : n >= 1e3 ? `${Math.round(n / 1e3)}K` : String(n || 0));

/** One voice: tap to choose; optional save (star) or remove (×). */
export default function VoiceCard({ voice, selected, onPick, onSave, onRemove, saved }) {
  return (
    <div data-testid={`jam-voice-${voice.id}`} className={`group relative flex items-center gap-2.5 rounded-2xl border p-2 transition-colors duration-200 ${selected ? "border-fuchsia-300/60 bg-fuchsia-500/[0.14]" : "border-white/[0.08] bg-white/[0.03] hover:bg-white/[0.07]"}`}>
      <button type="button" data-testid={`jam-voice-pick-${voice.id}`} onClick={() => onPick(voice)} className="flex min-w-0 flex-1 items-center gap-2.5 text-left">
        {voice.image_url ? <img src={voice.image_url} alt="" className="h-10 w-10 shrink-0 rounded-xl object-cover" loading="lazy" />
          : <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-fuchsia-500/20 font-display text-sm text-fuchsia-100">{voice.name.slice(0, 1)}</span>}
        <span className="min-w-0">
          <span className="block truncate font-display text-[13px] font-semibold">{voice.name}</span>
          <span className="block truncate font-mono text-[9px] uppercase tracking-wider text-white/45">
            {voice.uses ? `${fmtUses(voice.uses)} uses` : voice.how === "added" ? "Added by you" : "Used before"}{voice.categories?.length ? ` · ${voice.categories.join(", ")}` : ""}
          </span>
        </span>
        {selected ? <Check className="ml-auto h-4 w-4 shrink-0 text-fuchsia-200" /> : null}
      </button>
      {onSave ? (
        <button type="button" data-testid={`jam-voice-save-${voice.id}`} onClick={() => onSave(voice)} disabled={saved} title={saved ? "In My voices" : "Save to My voices"}
          className="shrink-0 text-white/40 hover:text-amber-200 disabled:text-amber-300"><Star className={`h-4 w-4 ${saved ? "fill-amber-300" : ""}`} /></button>
      ) : null}
      {onRemove ? (
        <button type="button" data-testid={`jam-voice-remove-${voice.id}`} onClick={() => onRemove(voice)} title="Remove from My voices" className="shrink-0 text-white/35 hover:text-rose-300"><X className="h-4 w-4" /></button>
      ) : null}
    </div>
  );
}
